/**
 * v1 launch ordering: paths listed first for a world surface before others
 * (after age-band match). Ties keep catalog order.
 *
 * @type {Record<string, string[]>}
 */
export const FLAGSHIP_PATH_IDS_BY_WORLD = {
  animals: ['animal-habitats'],
  robotics: ['gears-and-motion', 'robot-path-sequencing'],
  math: ['number-patterns'],
  space: ['space-missions'],
};

/**
 * @param {string} worldId
 * @param {string} pathId
 * @returns {number} sort key (lower = earlier)
 */
export function flagshipPathSortKey(worldId, pathId) {
  const list = FLAGSHIP_PATH_IDS_BY_WORLD[worldId];
  if (!list || !pathId) return 1000;
  const idx = list.indexOf(pathId);
  return idx === -1 ? 500 : idx;
}
